import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import PaginationObj from '../../pojo/PaginationObj';
import template from './pagination.vue';

@Component({
    mixins: [template],
})
export default class Pagination extends Vue {
    @Prop()
    pagination: PaginationObj;

    pageSize: number;
    currentPage: number;
    totalSize: number;
    text: string;

    goToPage(pageNum: number) {
        this.$emit('goToPage', pageNum);
    }

    @Watch('pagination', {
        immediate: true,
        deep: true,
    })
    initPage() {
        this.init();
    }

    hasPages() {
        return this.totalSize >= 1 && this.currentPage >= 1 && this.pageSize >= 1;
    }

    startNum() {
        if (!this.hasPages()) {
            return 0;
        }
        return (this.currentPage - 1) * this.pageSize + 1;
    }

    init() {
        this.pageSize = this.pagination.pageSize;
        this.currentPage = this.pagination.currentPage;
        this.totalSize = this.pagination.totalSize;
        this.text = this.pagination.text || '';
        this.getTotalSize();
        this.getTotalPages();
        this.displayText();
        this.getTotalPageList();
        this.$forceUpdate();
    }

    endNum() {
        if (!this.hasPages()) {
            return 0;
        }
        if (this.currentPage * this.pageSize > this.totalSize) {
            return this.totalSize;
        }
        return this.currentPage * this.pageSize;
    }

    getTotalSize() {
        if (this.totalSize < 1) {
            this.totalSize = 0;
        }
        return this.totalSize;
    }

    getTotalPages() {
        if (!this.hasPages()) {
            return 0;
        }
        return Math.ceil(this.getTotalSize() / this.pageSize);
    }

    getTotalPageList() {
        let totalPages = [];
        for (let i = 0; i < this.getTotalPages(); i++) {
            let page = { pageNum: i + 1 };
            totalPages.push(page);
        }
        return totalPages;
    }

    /**
     *
     * @returns example: Showing 1-10 of 45 customers
     */
    displayText() {
        if (!this.hasPages()) {
            return '';
        }
        return (
            'Showing ' +
            this.startNum() +
            ' - ' +
            this.endNum() +
            ' of ' +
            this.totalSize +
            ' ' +
            this.text
        );
    }

    nextPage() {
        if (this.currentPage >= this.getTotalPages()) {
            return this.currentPage;
        }
        this.currentPage += 1;
        this.$emit('goToPage', this.currentPage);
    }

    prePage() {
        if (this.currentPage <= 1) {
            return this.currentPage;
        }
        this.currentPage -= 1;
        this.$emit('goToPage', this.currentPage);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/pagination/index.ts